export const IMPORTANT_PATIENT_INFORMATION = 'Important patient information';

const OTHER_SECTION_OPTIONS = [
  'Medicines to prevent blood clots',
  'Ungrouped medications',
  'Heart and/or blood pressure medicines',
  'Medicines to be taken when required',
  'Short term medicines',
  'These medicines are in the pack prepared for you by your community pharmacy',
  'These medicines are NOT in the pack prepared for you by your community pharmacy',
  'Diabetes medicines',
  'Pain medicines',
  'Bowel medicines',
  'Cancer medicines',
  'Urinary tract system medicines',
  'Antibiotics',
  'Mental Health medicines',
  'Inhaled medicines',
  'Medications given by infusion',
  'Regular medicines',
  'Medications given by injection',
  'HELD MEDICINES - DO NOT TAKE THESE MEDICINES UNTIL YOU SPEAK TO YOUR GP',
  'COPD Action Plan - Emergency Pack Medicines',
  'Short term and when required medicines',
  'Medicines packed in your dosing aid',
  'Medicines NOT packed in your dosing aid',
  'Medicines to apply to the SCALP',
  'Medicines to apply to the FACE',
  'Medicines to apply to the BODY (Trunk and Limbs)',
  'Medicines and products to support and assist your SKIN',
] as const;

export const MED_SECTION_OPTIONS = [...OTHER_SECTION_OPTIONS] as const;

export type MedSectionOption = {
  label: string;
  value: string;
};

export const medSectionOptions: MedSectionOption[] = MED_SECTION_OPTIONS.map(
  (label) => ({ label, value: label }),
);

enum MedicationChangeType {
  NONE = 'None',
  NEW_MEDICINES = 'New medicines',
  DOSE_INCREASE = 'Dose Increase',
  DOSE_DECREASE = 'Dose Decrease',
  HELD_MEDICINES = 'Held Medicines – Do not take these until reviewed by your doctor',
  STOPPED_MEDICINES = 'Stopped Medicines – Do NOT take these anymore',
  DOSE_TIME_CHANGED = 'Dose Time Changed',
  FORMULATION_CHANGED = 'Formulation changed',
  RESTARTED_MEDICINES = 'Restarted medicines',
  SHORT_TERM_MEDICINES = 'Short term medicines',
}

export const MedicationChangeTypeLabel: Record<MedicationChangeType, string> = {
  [MedicationChangeType.NEW_MEDICINES]: 'New Medicines',
  [MedicationChangeType.NONE]: 'No Changes',
  [MedicationChangeType.DOSE_INCREASE]: 'Dose Increased',
  [MedicationChangeType.DOSE_DECREASE]: 'Dose Decreased',
  [MedicationChangeType.HELD_MEDICINES]: 'Medicines Held',
  [MedicationChangeType.STOPPED_MEDICINES]: 'Medicines Stopped',
  [MedicationChangeType.DOSE_TIME_CHANGED]: 'Dose Time Changed',
  [MedicationChangeType.FORMULATION_CHANGED]: 'Formulation Changed',
  [MedicationChangeType.RESTARTED_MEDICINES]: 'Medicines Restarted',
  [MedicationChangeType.SHORT_TERM_MEDICINES]: 'Short Term Medicines',
};

enum MedicationSectionBreak {
  ANTIBIOTICS = 'Antibiotics',
  BLOOD_CLOT_PREVENTION = 'Medicines to prevent blood clots',
  HEART_BLOOD_PRESSURE = 'Heart and/or blood pressure medicines',
  AS_REQUIRED = 'Medicines to be taken when required',
  SHORT_TERM = 'Short term medicines',
  DIABETES = 'Diabetes medicines',
  PAIN = 'Pain medicines',
  BOWEL = 'Bowel medicines',
  CANCER = 'Cancer medicines',
  MENTAL_HEALTH = 'Mental Health medicines',
  INHALED = 'Inhaled medicines',
  INFUSION = 'Medications given by infusion',
  REGULAR = 'Regular medicines',
  INJECTION = 'Medications given by injection',
  HELD_MEDICINES = 'HELD MEDICINES - DO NOT TAKE THESE MEDICINES UNTIL YOU SPEAK TO YOUR GP',
  COPD_EMERGENCY = 'COPD Action Plan - Emergency Pack Medicines',
  SHORT_TERM_AS_REQUIRED = 'Short term and when required medicines',
  UNGROUPED = 'Ungrouped medications',
  IN_PACK = 'These medicines are in the pack prepared for you by your community pharmacy',
  NOT_IN_PACK = 'These medicines are NOT in the pack prepared for you by your community pharmacy',
  URINARY = 'Urinary tract system medicines',
  IN_DOSING_AID = 'Medicines packed in your dosing aid',
  NOT_IN_DOSING_AID = 'Medicines NOT packed in your dosing aid',
}

export const MedicationSectionBreakLabel: Record<
  MedicationSectionBreak,
  string
> = {
  [MedicationSectionBreak.ANTIBIOTICS]: 'Antibiotics',
  [MedicationSectionBreak.AS_REQUIRED]: 'As Required',
  [MedicationSectionBreak.BLOOD_CLOT_PREVENTION]: 'Blood Clot Prevention',
  [MedicationSectionBreak.BOWEL]: 'Bowel',
  [MedicationSectionBreak.CANCER]: 'Cancer',
  [MedicationSectionBreak.COPD_EMERGENCY]: 'COPD Emergency',
  [MedicationSectionBreak.DIABETES]: 'Diabetes',
  [MedicationSectionBreak.HEART_BLOOD_PRESSURE]: 'Heart & Blood Pressure',
  [MedicationSectionBreak.HELD_MEDICINES]: 'Held Medicines',
  [MedicationSectionBreak.INFUSION]: 'Infusion',
  [MedicationSectionBreak.INHALED]: 'Inhaled',
  [MedicationSectionBreak.INJECTION]: 'Injection',
  [MedicationSectionBreak.IN_DOSING_AID]: 'In Dosing Aid',
  [MedicationSectionBreak.NOT_IN_DOSING_AID]: 'Not In Dosing Aid',
  [MedicationSectionBreak.IN_PACK]: 'In Pack',
  [MedicationSectionBreak.NOT_IN_PACK]: 'Not In Pack',
  [MedicationSectionBreak.MENTAL_HEALTH]: 'Mental Health',
  [MedicationSectionBreak.PAIN]: 'Pain',
  [MedicationSectionBreak.REGULAR]: 'Regular',
  [MedicationSectionBreak.SHORT_TERM]: 'Short Term',
  [MedicationSectionBreak.SHORT_TERM_AS_REQUIRED]: 'Short Term & As Required',
  [MedicationSectionBreak.UNGROUPED]: 'Ungrouped',
  [MedicationSectionBreak.URINARY]: 'Urinary',
};
